const TELEGRAM_ORIGIN_HOST = 't.me';
const TELEGRAM_ORIGIN_URL = `https://${TELEGRAM_ORIGIN_HOST}`;
const INTERCOM_APP_ID = 'n0a1uomx';
const GOOGLE_TAG_MANAGER_ID = 'GTM-5D9TR4B';

const FEATURES = {};

export {
  TELEGRAM_ORIGIN_HOST,
  TELEGRAM_ORIGIN_URL,
  INTERCOM_APP_ID,
  GOOGLE_TAG_MANAGER_ID,

  FEATURES,
};
